module.exports = __webpack_public_path__ + "img/website.3f46aea4.svg";